module.exports = __webpack_public_path__ + "img/foto-fundo.36cf54ca.jpg";